import { createApiService } from "./apiServiceFactory";
import type { simulation } from "@/features/dashboard/types.api";
import type { simulationFormData } from "@/features/userManagement/components/userFormModal/types.props";
import type { simulationFilters } from "@/features/simulationManagement/types.props";

export const simulationService = createApiService<
    simulation,
    simulationFilters,
    simulationFormData
>("simulations");
